"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.googleDriveDownloadFile = exports.googleDriveDownloadFileResultSchema = exports.googleDriveDownloadFileArgsSchema = void 0;
var zod_1 = require("zod");
var common_1 = require("./common");
exports.googleDriveDownloadFileArgsSchema = (0, common_1.PipedreamNodeArgsSchema)('download-file', zod_1.z.object({
    fileId: zod_1.z
        .string()
        .describe('The fileId of the file we want to download. Must be fetched from user messages.'),
    mimeType: zod_1.z
        .string()
        .describe('The mimetype of the file we want to download. Must be fetched from user messages.'),
}));
exports.googleDriveDownloadFileResultSchema = (0, common_1.PipedreamNodeResultSchema)(zod_1.z.object({
    type: zod_1.z.literal('file'),
    fileType: zod_1.z.string(),
    filename: zod_1.z.string(),
    source: zod_1.z.object({
        kind: zod_1.z.union([zod_1.z.literal('raw'), zod_1.z.literal('url')]),
        value: zod_1.z.string(),
    }),
}));
exports.googleDriveDownloadFile = (0, common_1.createToolMetadata)({
    id: 'googleDriveDownloadFile',
    displayName: 'Google Drive Download File',
    displayDescription: 'Retrieve a download link for a file from Google Drive',
    category: 'integration',
    color: common_1.BRAND_COLORS.GOOGLE_DRIVE,
    backgroundColor: (0, common_1.createBgColor)(common_1.BRAND_COLORS.GOOGLE_DRIVE),
    icon: 'google_drive',
    argsSchema: exports.googleDriveDownloadFileArgsSchema,
}, exports.googleDriveDownloadFileResultSchema);
